import { useState, useEffect, useRef, useCallback } from 'react';
export const useDebouncedCallback = (fn, waitTime) => {
  const timeout = useRef();
  return useCallback((...args) => {
    const delayedExecution = () => {
      clearTimeout(timeout.current);
      fn(...args);
    };
    clearTimeout(timeout.current);
    timeout.current = setTimeout(delayedExecution, waitTime);
  }, [fn, waitTime]);
};
export const useResize = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const handleResize = useDebouncedCallback(() => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, 100);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
  return windowDimensions;
};